// extracted by mini-css-extract-plugin
module.exports = {"card":"Intro_card__1Oz6Q","heading":"Intro_heading__3_HGY","profile_info":"Intro_profile_info__3-bWE","btn":"Intro_btn__zx2v4"};